/* ==========================================================================
 *  Function: Add navingation scroll
 * ======================================================================= */

var windowScrollTop;
var windowWidth;
var counterTop;
var counterHeight;
var navigationHeight;

var mapTop;
var mapShow = false;

if ($('.navigation').length){
	var navigation = $('.navigation');
}

if ($('#counter-section').length){
	var counterGroup = $('#counter-section');
}

if ($('.js-map').length){
	var map = $('.js-map');
}

var counterAnimationOnce = false;

function fn_parts_scroll_resize(){
	windowScrollTop = $(window).scrollTop();
	windowWidth = $(window).width();

	if ($('.navigation').length){
		if (windowScrollTop > 1 && windowWidth > bp_small) {
			navigation.addClass( 'navigation-scroll' );
		} else {
			navigation.removeClass( 'navigation-scroll' );
		}
	}

	if ($('#counter-section').length && !counterAnimationOnce){
		counterTop = $('#counter-section').offset().top - ( $(window).height() / 2 );
		counterHeight = $('#counter-section').outerHeight();
		navigationHeight = $('.navigation').height();
		if (windowScrollTop > counterTop - navigationHeight  ) {
			fn_components_counter();
			counterAnimationOnce = true;
		}
	}

	if ($('.js-map').length && !mapShow){
		mapTop = map.offset().top - 700;
		if (windowScrollTop > mapTop  ) {
			fn_components_google_map();
			mapShow = true;
		}
	}
}
